import { useEffect, useState } from "react";
import { api, idr } from "../../lib/api";
import { toast } from "sonner";
import { Check, X, ClipboardCheck, AlertCircle } from "lucide-react";
import LoadingState from "../../components/ui/loading-state";
import { formatTanggal } from "../../lib/tanggal";

export default function FinanceApproval() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  const load = async () => {
    setLoading(true);
    setLoadError(null);
    try {
      const r = await api.get("/finance/approval/pending");
      setItems(r.data.items || []);
    } catch (e) { setLoadError(e); toast.error("Gagal memuat"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const decide = async (item, action) => {
    let reason = "";
    if (action === "reject") { reason = prompt("Alasan penolakan?") || ""; if (!reason) return; }
    try {
      const base = item.entity === "piutang" ? "piutang" : item.entity === "utang" ? "utang" : "transactions";
      const r = await api.post(`/finance/${base}/${item.id}/${action}`, action === "reject" ? { reason } : {});
      toast.success(r.data.message || "OK"); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };

  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="finance-approval">
      <div>
        <p className="text-[11px] text-slate-500 uppercase tracking-wider font-semibold">Approval SPV</p>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900 mt-1">Menunggu Persetujuan</h1>
        <p className="text-sm text-slate-600 mt-1">Transaksi ≥ threshold dari finance_staff yang butuh review SPV.</p>
      </div>
      <LoadingState loading={loading} error={loadError} onRetry={load} varian="kartu" jumlahKartu={2} data-testid="loading-approval">
        {items.length === 0 ? (
          <div className="bg-white border border-slate-200 rounded-xl p-10 text-center shadow-sm">
            <ClipboardCheck className="w-12 h-12 mx-auto text-emerald-500 mb-3" />
            <p className="font-display font-bold text-lg text-slate-900">Tidak ada yang menunggu</p>
            <p className="text-sm text-slate-500 mt-1">Semua transaksi sudah beres. 🎉</p>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map(it => (
              <div key={`${it.entity}-${it.id}`} className="bg-white border border-amber-200 border-l-4 border-l-amber-500 rounded-xl p-4 shadow-sm">
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <AlertCircle className="w-4 h-4 text-amber-600 shrink-0" />
                      <p className="text-[10px] font-semibold uppercase tracking-wider text-amber-700">{it.entity} · {it.code}</p>
                    </div>
                    <p className="font-display font-bold text-slate-900">{it.description}</p>
                    <p className="text-2xl font-bold text-slate-900 mt-1">{idr(it.nominal)}</p>
                    <p className="text-xs text-slate-500 mt-1">Diajukan oleh {it.created_by_name} · {formatTanggal(it.tanggal)}</p>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => decide(it, "reject")} data-testid={`appr-reject-${it.id}`} className="h-10 px-3 rounded-lg bg-rose-50 text-rose-700 hover:bg-rose-100 text-sm font-medium border border-rose-200 inline-flex items-center gap-1"><X className="w-4 h-4" /> Tolak</button>
                    <button onClick={() => decide(it, "approve")} data-testid={`appr-approve-${it.id}`} className="h-10 px-3 rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 text-sm font-medium inline-flex items-center gap-1"><Check className="w-4 h-4" /> Setujui</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </LoadingState>
    </div>
  );
}
